<!-- <div class="fixed z-10">
  <label class="font-bold">Dealer ID:</label>
  <input type="text" [(ngModel)]="dealerId" class="default-input" />
  <button class="default-border ml-2 p-2" (click)="setDealerById()">Set Dealer</button>
</div> -->

<video #dealerVideo id="dealerVideo" [controls]="true" [autoplay]="true" [muted]="true"></video>

<div class="fixed z-10 mt-5 flex w-full items-center justify-between bg-opacity-80 px-36 py-2">
  <p class="justify-items-center text-xl font-bold text-brand-gold-1">
    Mode: {{ modeDescription }}
  </p>
  <div>
    <app-timer *ngIf="countdown > 0" [countdown]="countdown"></app-timer>
  </div>
</div>
<!-- <div
  class="absolute right-0 top-0 bg-zinc-800 bg-opacity-70 px-4 py-4"
  *ngIf="showConfirmationPanel"
>
  <p class="text-center text-lg font-medium">
    {{ confirmationDescription ? 'Player Cards' : 'Maverick Card' }}
  </p>
  <div class="flex items-center justify-center space-x-2">
    <ng-container *ngFor="let card of displayedCards">
      <div class="relative">
        <img
          src="../../assets/cards/{{ card.cardType }}/{{ card.number }}-{{ card.cardType }}.svg"
          class="h-auto w-52"
        />

        <p class="p-1 text-center text-sm font-medium">
          {{ card.label.toUpperCase() }}
        </p>
      </div>
    </ng-container>
  </div>
  <div class="flex items-center justify-center space-x-8">
    <app-button
      [success]="true"
      [rounded]="true"
      [md]="true"
      class="mt-2 flex items-center justify-center"
      (click)="confirmCards(true)"
    >
      CONFIRM
    </app-button>
    <app-button
      [danger]="true"
      [rounded]="true"
      [md]="true"
      class="mt-2 flex items-center justify-center"
      (click)="confirmCards(false)"
    >
      DENY
    </app-button>
  </div>
</div> -->
